// payment-processing.js (웹 페이지)
import React, { useEffect, useState } from "react";
import { sendToRN } from "../utils/webviewBridge";

export default function PaymentProcessing() {
  const [status, setStatus] = useState("processing");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const processPayment = async () => {
      try {
        const params = new URLSearchParams(window.location.search);

        // ✅ URL에서 받은 모든 파라미터 확인
        console.log("[PaymentProcessing] URL 파라미터 전체:", {
          URL: window.location.href,
          "모든 파라미터": Object.fromEntries(params.entries()),
        });

        // ✅ 토스가 전달하는 파라미터 (paymentKey, orderId, amount)
        const paymentKey = params.get("paymentKey");
        const orderId = params.get("orderId"); // 토스가 전달하는 orderId
        const amount = params.get("amount");
        // ✅ 우리가 전달한 파라미터
        const orderNumber = params.get("orderNumber") || orderId;
        const parentToken =
          params.get("parentToken") || sessionStorage.getItem("parentToken");

        console.log("[PaymentProcessing] 결제 처리 시작:", {
          paymentKey,
          orderId,
          orderNumber,
          amount,
          parentToken: parentToken ? "***존재***" : "null",
          hasAskRN: typeof window.__askRN === "function",
        });

        // ✅ paymentKey나 amount가 없으면 에러
        if (!paymentKey || !amount) {
          throw new Error(
            `결제 정보가 누락되었습니다. paymentKey: ${paymentKey}, amount: ${amount}`
          );
        }

        // ✅ sendToRN 사용 (RN 브리지가 없으면 자동으로 HTTP API 폴백)
        const requestPayload = {
          orderNumber: orderNumber,
          paymentKey: paymentKey,
          orderId: orderId || orderNumber,
          amount: Number(amount),
          parentToken: parentToken,
        };

        console.log("=".repeat(60));
        console.log("[PaymentProcessing] 🚀 결제 승인 요청 시작");
        console.log("=".repeat(60));
        console.log("[PaymentProcessing] 📤 백엔드로 전달하는 데이터:", {
          orderNumber,
          paymentKey: paymentKey ? `${paymentKey.slice(0, 20)}...` : null,
          orderId: orderId || orderNumber,
          amount: Number(amount),
          parentToken: parentToken ? "***존재***" : null,
          전체_URL: window.location.href,
        });
        console.log("=".repeat(60));

        const response = await sendToRN("REQUEST_PAYMENT", requestPayload);

        console.log("=".repeat(60));
        console.log("[PaymentProcessing] ✅ 결제 승인 완료");
        console.log("=".repeat(60));
        console.log("[PaymentProcessing] 📥 백엔드 응답:", response);
        console.log("=".repeat(60));
        setStatus("success");

        // 1초 후 complete-payment 페이지로 이동
        setTimeout(() => {
          const passTypeFromResponse =
            response.data?.passType || response.result?.passType;
          const passTypeFromSession =
            sessionStorage.getItem("payment:passType");
          const finalPassType =
            passTypeFromResponse || passTypeFromSession || "";

          console.log("[PaymentProcessing] 🔍 passType 결정:", {
            "response.data?.passType": response.data?.passType,
            "response.result?.passType": response.result?.passType,
            "sessionStorage passType": passTypeFromSession,
            "최종 passType": finalPassType,
          });

          const redirectParams = new URLSearchParams({
            orderNumber: orderNumber,
            paymentKey: paymentKey,
            orderId: orderId || orderNumber,
            amount: amount,
            aggregateId:
              response.data?.aggregateId || response.result?.aggregateId || "",
            passType: finalPassType,
            storeId: response.data?.storeId || response.result?.storeId || "",
            storeName:
              response.data?.storeName ||
              response.result?.storeName ||
              sessionStorage.getItem("payment:storeName") ||
              "",
          });

          // ✅ 대리인 결제일 경우 parentToken 추가
          if (parentToken) {
            redirectParams.append("parentToken", parentToken);
          }

          window.location.href = `/complete-payment?${redirectParams.toString()}`;
        }, 1000);
      } catch (error) {
        console.error("❌ 결제 승인 실패:", error);
        setStatus("error");
        setMessage(error.message || "결제 승인에 실패했습니다.");

        // 3초 후 결제 페이지로 돌아가기
        setTimeout(() => {
          const params = new URLSearchParams(window.location.search);
          const orderNumber = params.get("orderNumber");
          window.location.href = `/cash?fail=1&orderNumber=${orderNumber}&message=${encodeURIComponent(
            error.message
          )}`;
        }, 3000);
      }
    };

    processPayment();
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "#f5f5f5",
      }}
    >
      {status === "processing" && (
        <div
          style={{
            textAlign: "center",
            padding: "40px",
            background: "white",
            borderRadius: "16px",
          }}
        >
          <div
            style={{
              width: "60px",
              height: "60px",
              border: "4px solid #f3f3f3",
              borderTop: "4px solid #4A90E2",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
              margin: "0 auto 20px",
            }}
          ></div>
          <h2>결제 처리 중입니다...</h2>
          <p>잠시만 기다려주세요.</p>
        </div>
      )}

      {status === "success" && (
        <div
          style={{
            textAlign: "center",
            padding: "40px",
            background: "white",
            borderRadius: "16px",
          }}
        >
          <div
            style={{ fontSize: "60px", color: "#4CAF50", marginBottom: "20px" }}
          >
            ✓
          </div>
          <h2>결제가 완료되었습니다!</h2>
          <p>결제 완료 페이지로 이동합니다...</p>
        </div>
      )}

      {status === "error" && (
        <div
          style={{
            textAlign: "center",
            padding: "40px",
            background: "white",
            borderRadius: "16px",
          }}
        >
          <div
            style={{ fontSize: "60px", color: "#f44336", marginBottom: "20px" }}
          >
            ✕
          </div>
          <h2>결제 승인에 실패했습니다</h2>
          <p>{message}</p>
          <p>결제 페이지로 돌아갑니다...</p>
        </div>
      )}
    </div>
  );
}
